import * as semrush from '@anm/helpers/semrush';

export const getUpgradeLinkProps = (upgradeLink = '/pricing', target = '_blank') => {
  const isSemrush = semrush.isSemrushIframe();

  return isSemrush ? { onClick: semrush.requestPurchase } : { href: upgradeLink, target };
};

export const getLinkTarget = (target = '_blank') => (semrush.isSemrushIframe() ? '_self' : target);
